import { render } from "./Yado.vue?vue&type=template&id=bf73e1e2&scoped=true"
import script from "./Yado.vue?vue&type=script&lang=js"
export * from "./Yado.vue?vue&type=script&lang=js"

import "./Yado.vue?vue&type=style&index=0&id=bf73e1e2&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf73e1e2"]])

export default __exports__